import { SettingsFormValues } from 'pages/SettingsV2/settingsTypes';

export const INITIAL_VALUE: SettingsFormValues = {
  productPrice: {
    groupPriceNames: ['', '', '', '', ''],
    usePrice: true,
    usePriceSale: true,
  },
  barcode: {
    idType: 'product_code',
    brand: 'see_dlabel',
    size: 'a7',
    layoutType: 1,
    customItemCode: true,
  },
  weightBarcode: {
    enabled: true,
    barcodeType: 'weight',
    prefix: '20',
    prefixLength: 2,
    pluDigits: 5,
    weightDigits: 5,
    checkLength: 1,
    checkType: 'ean13',
    valueDecimals: 3,
    totalLength: 13,
    formatMask: 'PP IIIII WWWWW C',
  },
  document: {
    companyLogoUrl: '',
    receiptLogoUrl: '',
    templateType: 'new',
    receiptComment: '',
    quotationComment: '',
  },
  rounding: {
    condition: 0,
    interval: null,
  },
  loyaltyPoints: {
    isActive: false,
    expiryYear: 1,
  },
  serviceCharge: {
    isActive: false,
    percent: 10,
    vat: 7,
  },
  invoiceCode: {
    prefix: '',
    type: 0,
    typeYear: 0,
    format: '',
    num: 0,
  },
};
